export default __webpack_public_path__ + "static/media/ranking_items.ac1710a0.svg";